import FormField from "components/form/FormField";
import { Box, Button, Text } from "components/ui";
import { Formik } from "formik";
import React, { useState } from "react";
import ScrollContainer from "components/general/ScrollContainer";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import Section from "components/general/Section";
import { ActivityIndicator } from "react-native";
import { usePostUserChangePasswordMutation } from "store/abcoApi";
import * as Yup from "yup";
import { useIsMobile } from "utils/hooks/useIsMobile";

export default function Page() {
	const isMobile = useIsMobile();
	const [postChangePassword] = usePostUserChangePasswordMutation();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	const validationSchema = Yup.object().shape({
		oldPassword: Yup.string().required("Current password is required"),
		newPassword: Yup.string()
			.required("New password is required")
			.min(8, "Password must be at least 8 characters")
			.matches(/[A-Z]/, "Password must contain at least one uppercase letter")
			.matches(/[a-z]/, "Password must contain at least one lowercase letter")
			.matches(/[0-9]/, "Password must contain at least one number")
			.matches(/[!@#$%^&*()_+\-=[\]{};:'\",.<>?]/, "Password must contain at least one special character"),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref("newPassword")], "Passwords must match")
			.required("Confirm password is required"),
	});

	return (
		<ScrollContainer>
			<Container>
				<PageHeader title="Change Password" />
				<Section>
					<Box>
						<Formik
							initialValues={{
								oldPassword: "",
								newPassword: "",
								confirmPassword: "",
							}}
							validationSchema={validationSchema}
							onSubmit={async (values, { resetForm }) => {
								setIsSubmitting(true);
								postChangePassword({ userChangePassword: values }).then((res) => {
									setIsSubmitting(false);

									if (res?.data) {
										setIsSuccess(true);
									} else {
										setIsSuccess(false);
									}
								});
							}}
						>
							{(formik) => (
								<Box gap={10} maxWidth={isMobile ? "auto" : 400}>
									{isSuccess && (
										<Text color="green" mb={10}>
											Your password has now been updated.
										</Text>
									)}
									<FormField label="Current Password" name="oldPassword" placeholder="Current Password" formik={formik} isPassword={true} />
									<FormField label="New Password" name="newPassword" placeholder="New Password" formik={formik} isPassword={true} />
									<FormField label="Confirm Password" name="confirmPassword" placeholder="Confirm Password" formik={formik} isPassword={true} />
									<Button width={120} variant="secondary" onPress={() => formik.handleSubmit()} disabled={!formik.isValid || formik.isSubmitting}>
										<Text>Save</Text>
										{isSubmitting && <ActivityIndicator size="small" style={{ position: "absolute", right: 12 }} />}
									</Button>
								</Box>
							)}
						</Formik>
					</Box>
				</Section>
			</Container>
		</ScrollContainer>
	);
}
